module.exports = __webpack_public_path__ + "media/images/team/daniel-d-7b0ab7ceeed3177bd32377fee48d4bb3.jpg";